import { CreatePickerEmpMap, PickerEmpList } from 'components/pickerEmpMap'
import { useCallback, useState } from 'react'
import { Helmet } from 'react-helmet'

const PickerEmpMapPage = () => {
  const [refetch, setRefetch] = useState<boolean>(false)

  const refetchMappings = useCallback(() => {
    setRefetch((prev) => !prev)
  }, [setRefetch])

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Picker Mapping Management</title>
      </Helmet>

      <div className="mx-auto w-full max-w-5xl ">
        <CreatePickerEmpMap refetchMappings={refetchMappings} />

        <PickerEmpList refetch={refetch} />
      </div>
    </>
  )
}

export default PickerEmpMapPage
